import clsx from "clsx"
import { ComponentPropsWithoutRef, forwardRef } from "react"

import { IconName } from "../../icons/build"
import { ControlSize, ThemeColor } from "../../types"
import { Icon } from "../Icon"
import cls from "./Select.module.scss"

type SelectProps = {
  dark?: boolean
  inputSize?: ControlSize
  iconLeft?: IconName
  iconLeftColor?: ThemeColor
  iconRight?: IconName
  iconRightColor?: ThemeColor
  wrapperClassName?: string
} & ComponentPropsWithoutRef<"select">

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      dark,
      iconLeft,
      iconRight = "chevron-tiny-down",
      inputSize = "medium",
      iconLeftColor,
      iconRightColor,
      className,
      wrapperClassName,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <div className={clsx(cls.selectWrapper, cls[inputSize], wrapperClassName)}>
        {iconLeft && <Icon name={iconLeft} color={iconLeftColor || "primary"} className={cls.iconLeft} />}

        <select
          className={clsx(
            cls.select,
            dark && cls.dark,
            iconLeft && cls.hasIconLeft,
            iconRight && cls.hasIconRight,
            className
          )}
          ref={ref}
          {...props}
        >
          {children}
        </select>

        {iconRight && (
          <Icon name={iconRight} color={iconRightColor || (dark ? "primary" : "muted")} className={cls.iconRight} />
        )}
      </div>
    )
  }
)
